import * as React from 'react';
import { usePersonDevicesBrowsername } from '../hooks';
import { ActorApiStringDisplay } from '../../../../../components/display/string';

export const PersonsDevicesBrowser = () => {
  const {
    data,
    isLoading,
    error,
  } = usePersonDevicesBrowsername();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
